import { StepTitleProps } from './StepTitle.types';
import * as S from './StepTitle.styles';

const StepTitle = (props: StepTitleProps): JSX.Element => <S.Container {...props} />;

export default StepTitle;
